<template>
    <div>
        <div :is="tabContent" :user-type="userTypes.customer" :open-id="$store.state.user.openId" @addconsult="addConsult"></div>
        <van-tabbar v-model="active">
            <van-tabbar-item  icon="home-o">新建</van-tabbar-item>
            <van-tabbar-item  icon="chat-o" >我的咨询</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import ConsultList from './ConsultList';
    import AddConsult from './AddConsult'
    import {userTypes} from '../../common/const'
  export default {
    name: "ConsultApprove",
    components: {
      ConsultList,
      AddConsult
    },
    data() {
      return {
        active: 0,
        userTypes
      }
    },
    methods:{
      addConsult(){
        this.active =1;
      }
    },
    computed:{
      tabContent(){
        if (this.active===0){
          return AddConsult
        } else if(this.active === 1){
          return ConsultList
        } else {
          return  AddConsult
        }
      }
    }
  }
</script>

<style scoped>

</style>